<script setup lang="ts">
defineOptions({ inheritAttrs: false });
</script>

<template>
    <VListItemTitle
        v-bind="$attrs"
        class="b-list-item-title"
    >
        <slot />
    </VListItemTitle>
</template>
